import { render, staticRenderFns } from "./AddPKBPage.vue?vue&type=template&id=17aa5fa5&"
import script from "./AddPKBPage.vue?vue&type=script&lang=js&"
export * from "./AddPKBPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports